'use client';

export default function WhatsAppButton() {
  return (
    <>
      <style data-component-id="src/components/WhatsAppButton.tsx:6:6" data-component-path="src/components/WhatsAppButton.tsx" data-component-line="6" data-component-end-line="31" data-component-file="WhatsAppButton.tsx" data-component-name="style" data-component-content="%7B%22elementName%22%3A%22style%22%7D">{`
        @keyframes whatsapp-ping {
          0% { transform: scale(1); opacity: 0.6; }
          100% { transform: scale(1.8); opacity: 0; }
        }
        @keyframes whatsapp-heartbeat {
          0%, 100% { transform: scale(1); }
          50% { transform: scale(1.08); }
        }
        .whatsapp-ring {
          position: absolute;
          inset: 0;
          border-radius: 50%;
          background-color: #25D366;
          animation: whatsapp-ping 1.5s ease-out infinite;
        }
        .whatsapp-ring-2 {
          animation-delay: 0.75s;
        }
        .whatsapp-icon-beat {
          animation: whatsapp-heartbeat 1.2s ease-in-out infinite;
        }
        .whatsapp-float:hover .whatsapp-icon-beat {
          animation: none;
        }
      `}</style>
      <a data-component-id="src/components/WhatsAppButton.tsx:32:6" data-component-path="src/components/WhatsAppButton.tsx" data-component-line="32" data-component-end-line="78" data-component-file="WhatsAppButton.tsx" data-component-name="a" data-component-content="%7B%22elementName%22%3A%22a%22%2C%22href%22%3A%22https%3A%2F%2Fwa.me%2F251911209336%22%2C%22className%22%3A%22whatsapp-float%22%7D"
        href="https://wa.me/251911209336"
        target="_blank"
        rel="noopener noreferrer"
        aria-label="Chat with us on WhatsApp"
        className="whatsapp-float"
        style={{
          position: 'fixed',
          bottom: '24px',
          right: '24px',
          zIndex: 50,
          width: '56px',
          height: '56px',
          borderRadius: '50%',
          backgroundColor: '#25D366',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          boxShadow: '0 4px 16px rgba(37,211,102,0.45)',
          transition: 'transform 0.2s ease, box-shadow 0.2s ease',
        }}
        onMouseEnter={e => {
          (e.currentTarget as HTMLAnchorElement).style.transform = 'scale(1.12)';
          (e.currentTarget as HTMLAnchorElement).style.boxShadow = '0 6px 24px rgba(37,211,102,0.6)';
        }}
        onMouseLeave={e => {
          (e.currentTarget as HTMLAnchorElement).style.transform = 'scale(1)';
          (e.currentTarget as HTMLAnchorElement).style.boxShadow = '0 4px 16px rgba(37,211,102,0.45)';
        }}
      >
        {/* Ping ring 1 */}
        <span data-component-id="src/components/WhatsAppButton.tsx:63:8" data-component-path="src/components/WhatsAppButton.tsx" data-component-line="63" data-component-end-line="63" data-component-file="WhatsAppButton.tsx" data-component-name="span" data-component-content="%7B%22elementName%22%3A%22span%22%2C%22className%22%3A%22whatsapp-ring%22%7D" className="whatsapp-ring" aria-hidden="true" />
        {/* Ping ring 2 (staggered) */}
        <span data-component-id="src/components/WhatsAppButton.tsx:65:8" data-component-path="src/components/WhatsAppButton.tsx" data-component-line="65" data-component-end-line="65" data-component-file="WhatsAppButton.tsx" data-component-name="span" data-component-content="%7B%22elementName%22%3A%22span%22%2C%22className%22%3A%22whatsapp-ring%20whatsapp-ring-2%22%7D" className="whatsapp-ring whatsapp-ring-2" aria-hidden="true" />
        <span data-component-id="src/components/WhatsAppButton.tsx:66:8" data-component-path="src/components/WhatsAppButton.tsx" data-component-line="66" data-component-end-line="77" data-component-file="WhatsAppButton.tsx" data-component-name="span" data-component-content="%7B%22elementName%22%3A%22span%22%2C%22className%22%3A%22whatsapp-icon-beat%22%7D" className="whatsapp-icon-beat" style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', position: 'relative', zIndex: 1 }}>
          <svg data-component-id="src/components/WhatsAppButton.tsx:67:10" data-component-path="src/components/WhatsAppButton.tsx" data-component-line="67" data-component-end-line="76" data-component-file="WhatsAppButton.tsx" data-component-name="svg" data-component-content="%7B%22elementName%22%3A%22svg%22%7D"
            xmlns="http://www.w3.org/2000/svg"
            viewBox="0 0 32 32"
            width="30"
            height="30"
            fill="white"
            aria-hidden="true"
          >
            <path data-component-id="src/components/WhatsAppButton.tsx:75:12" data-component-path="src/components/WhatsAppButton.tsx" data-component-line="75" data-component-end-line="75" data-component-file="WhatsAppButton.tsx" data-component-name="path" data-component-content="%7B%22elementName%22%3A%22path%22%7D" d="M16 0C7.163 0 0 7.163 0 16c0 2.822.736 5.469 2.027 7.773L0 32l8.476-2.004A15.934 15.934 0 0016 32c8.837 0 16-7.163 16-16S24.837 0 16 0zm0 29.333a13.267 13.267 0 01-6.763-1.845l-.485-.288-5.03 1.188 1.21-4.898-.317-.503A13.267 13.267 0 012.667 16C2.667 8.636 8.636 2.667 16 2.667S29.333 8.636 29.333 16 23.364 29.333 16 29.333zm7.27-9.878c-.398-.199-2.355-1.162-2.72-1.295-.365-.133-.63-.199-.896.199-.265.398-1.029 1.295-1.261 1.56-.232.265-.465.299-.863.1-.398-.199-1.681-.62-3.203-1.977-1.184-1.056-1.983-2.36-2.215-2.758-.232-.398-.025-.613.174-.811.179-.178.398-.465.597-.697.199-.232.265-.398.398-.664.133-.265.066-.498-.033-.697-.1-.199-.896-2.16-1.228-2.957-.323-.776-.651-.671-.896-.683l-.764-.013c-.265 0-.697.1-.1063.498-.365.398-1.394 1.362-1.394 3.322s1.427 3.854 1.626 4.12c.199.265 2.808 4.286 6.803 6.012.951.41 1.693.655 2.272.839.954.304 1.823.261 2.51.158.766-.114 2.355-.963 2.688-1.893.333-.93.333-1.727.232-1.893-.1-.166-.365-.265-.763-.465z"/>
          </svg>
        </span>
      </a>
    </>
  );
}
